import { Params } from '@angular/router';
import { fromJS, Record } from 'immutable';
import { extend, isNil, omitBy } from 'lodash';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../utils/helpers/model.helper';
import { DateIncrementEnum, ReportParamsEnum } from '../reports.enum';
import { QueryDate } from './query-date.model';

export const DATE_RANGE_SCHEMA = Object.freeze({
  INCREMENT: DateIncrementEnum,
  START: QueryDate,
  END: QueryDate,
});
export const RECORD = generateSchema(DATE_RANGE_SCHEMA);
export const KEYS: any = generateKeys(DATE_RANGE_SCHEMA);

export class DateRange extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    const selfModel = setInModel(this, [
      {
        key: KEYS.START,
        value: new QueryDate(this.start),
      },
      {
        key: KEYS.END,
        value: new QueryDate(this.end),
      },
    ]);

    return selfModel as DateRange;
  }

  get increment(): DateIncrementEnum {
    return this.get(KEYS.INCREMENT);
  }

  get start(): QueryDate {
    return this.get(KEYS.START);
  }

  get end(): QueryDate {
    return this.get(KEYS.END);
  }

  get queryParams(): Params {
    const yearRange = {
      [ReportParamsEnum.date_increment]: this.increment,
      [ReportParamsEnum.start_year]: this.start.year,
      [ReportParamsEnum.end_year]: this.end.year,
    };
    const incrementRange = this.isMonthlyIncrement()
      ? {
          [ReportParamsEnum.start_month]: this.start.month,
          [ReportParamsEnum.end_month]: this.end.month,
        }
      : {
          [ReportParamsEnum.start_quarter]: this.start.quarter,
          [ReportParamsEnum.end_quarter]: this.end.quarter,
        };
    const dateRange = extend({}, yearRange, incrementRange);

    return omitBy(dateRange, isNil);
  }

  isMonthlyIncrement(): boolean {
    return this.increment === DateIncrementEnum.month;
  }
}
